import React from "react";
import { useState, useEffect } from "react";
import "./AddingServices.css";
import Editor from "../../../Utility/textEditor/editor";
import { useLocation, useNavigate } from "react-router-dom";
import url from "../../../Utility/URL/url";
import constant from "../../../Utility/Constants/constant";
import axios from "axios";
import { toast } from "react-toastify";
import getUsernameFromSession from "../../../Utility/gettingInformation/getUsernameFromSession";
import authHeader from "../../../headerTokenUtility/auth.header";

function AddingService() {
  const username = getUsernameFromSession();
  const location = useLocation();
  const callsButtons = [
    { value: "15" },
    { value: "30" },
    { value: "45" },
    { value: "60" },
    { value: "Custom" },
  ];
  const [serviceJson, setServiceJson] = useState({
    selectedType: "",
    callDuration: "",
    selectedPrice: "",
    description: "",
    shortDescription: "",
    title: "",
    customCallValue: "",
    customPriceValue: "",
    hideInProfileFlag: false,
  });
  const [edit, setEdit] = useState(false);
  const [showCancelPopup, setShowCancelPopup] = useState(false);

  // initial empty state (for reset)
  const initialState = {
    selectedType: "",
    callDuration: "",
    selectedPrice: "",
    description: "",
    shortDescription: "",
    title: "",
    customCallValue: "",
    customPriceValue: "",
    hideInProfileFlag: false,
  };

  const serviceTypeList = [
    {
      name: "1:1 Call",
      icon: (
        <i
          className="fa-regular fa-square-check"
          style={{ color: "#a7a7a7" }}
        ></i>
      ),
    },
    {
      name: "Text Query",
      icon: (
        <i className="fa-regular fa-message" style={{ color: "#a7a7a7" }}></i>
      ),
    },
  ];

  const [errors, setErrors] = useState({});
  const priceButtons = [
    { value: "200" },
    { value: "500" },
    { value: "1000" },
    { value: "Custom" },
  ];
  const navigate = useNavigate();

  function handleToggleButton(event) {
    const { checked } = event.target;
    setServiceJson((currServiceJson) => {
      return { ...currServiceJson, hideInProfileFlag: checked };
    });
  }
  useEffect(() => {
    //checking if the service is true it means we need to enable the edit option.
    // const service = location.state ? location.state.service : "";
const state = location.state;
  const service = state?.service; 
  const duplicateService = state?.duplicateFrom; // service for duplicate
    if (service) {

       setEdit(true);
      setServiceJson((currValue) => {
        // console.log(service);
        let customCallValue = checkCallDuration(service.callDuration);

        let customPriceValue = checkCustomPrice(service.price);

        //edit page.all the fields need edit values.
        let prePopulatedJson = {
          title: service.title,
          callDuration:
            service.type === constant.TEXT_QUERY
              ? ""
              : customCallValue
              ? "Custom"
              : service.callDuration,
          selectedPrice: customPriceValue ? "Custom" : service.price,
          selectedType:
            service.type === constant.ONE_ON_ONE_CALL
              ? "1:1 Call"
              : "Text Query",
          customCallValue:
            service.type === constant.TEXT_QUERY
              ? ""
              : customCallValue
              ? service.callDuration
              : "",
          customPriceValue: customPriceValue ? service.price : "",
          description: service.description,
          shortDescription: service.shortDescription,
          hideInProfileFlag: service.hideInProfileFlag,
        };

        return currValue !== prePopulatedJson ? prePopulatedJson : currValue;
      });
     return; // END EDIT CASE
  }
     // ===== DUPLICATE CASE =====
  if (duplicateService) {
    setEdit(false); // Duplicate is NOT edit mode

    setServiceJson((currValue) => {
      let customCallValue = checkCallDuration(duplicateService.callDuration);
      let customPriceValue = checkCustomPrice(duplicateService.price);

      let prePopulatedJson = {
        title: duplicateService.title,
        callDuration:
          duplicateService.type === constant.TEXT_QUERY
            ? ""
            : customCallValue
            ? "Custom"
            : duplicateService.callDuration,
        selectedPrice: customPriceValue ? "Custom" : duplicateService.price,
        selectedType:
          duplicateService.type === constant.ONE_ON_ONE_CALL
            ? "1:1 Call"
            : "Text Query",
        customCallValue:
          duplicateService.type === constant.TEXT_QUERY
            ? ""
            : customCallValue
            ? duplicateService.callDuration
            : "",
        customPriceValue: customPriceValue ? duplicateService.price : "",
        description: duplicateService.description,
        shortDescription: duplicateService.shortDescription,
        hideInProfileFlag: duplicateService.hideInProfileFlag,
      };

      return prePopulatedJson;
    });
    return; // STOP here for duplicate
  }

  // ===== NEW ENTRY CASE =====
  setEdit(false);
  setServiceJson(initialState);
}, []);

  // useEffect(() => console.log(serviceJson), [serviceJson]);
  function checkCallDuration(callDuration) {
    let selectedCallValue = callsButtons.find(
      (json) => callDuration == json.value
    );

    return !selectedCallValue;
  }
  function checkCustomPrice(price) {
    let selectedPriceValue = priceButtons.find((json) => price == json.value);
    return !selectedPriceValue;
  }
  function goBack() {
    navigate(-1);
  }

  function handleEditorChange(content) {
    setServiceJson(() => ({ ...serviceJson, description: content }));
  }
 async function handleConfirm() {
  let errors = checkValidation();
  let keys = Object.keys(errors);
  let count = keys.reduce((acc, curr) => (errors[curr] ? acc + 1 : acc), 0);

  const {
    selectedType,
    selectedPrice,
    callDuration,
    description,
    title,
    shortDescription,
    customCallValue,
    customPriceValue,
    hideInProfileFlag,
  } = serviceJson;

  if (count === 0) {
    setErrors((prevErrors) => (prevErrors !== errors ? errors : prevErrors));

    if (edit) {
      // ===== EDIT MODE =====
      const service = location.state.service;
      const payload = {
        username: username,
        title: title,
        shortDescription: shortDescription,
        price: selectedPrice !== "Custom" ? selectedPrice : customPriceValue,
        description: description,
        additionalQuestion: "What is your field",
        hideInProfileFlag: hideInProfileFlag ? 1 : 0,
        type: selectedType === "1:1 Call" ? constant.ONE_ON_ONE_CALL : constant.TEXT_QUERY,
        availability: "default",
        // Keep existing displayPriority when editing
        displayPriority: service.displayPriority,
      };

      // Add callDuration only for 1:1 Call
      if (selectedType === "1:1 Call") {
        payload.callDuration = callDuration !== "Custom" ? callDuration : customCallValue;
      }

      axios
        .put(url.PUT_SERVICE_BY_SERVICE_ID + service.platformServiceId, payload, {
          headers: authHeader(),
        })
        .then((response) => {
          if (response.request.status === 200) {
            toast.success("Service is updated at your profile!", {
              position: toast.POSITION.TOP_CENTER,
            });
            navigate(-1);
          }
        });
    } else {
      // ===== ADD NEW SERVICE =====
      const nextDisplayPriority = await getNextDisplayPriority();
      const payload = {
        username: username,
        title: title,
        shortDescription: shortDescription,
        price: selectedPrice !== "Custom" ? selectedPrice : customPriceValue,
        description: description,
        additionalQuestion: "What is your field",
        hideInProfileFlag: hideInProfileFlag ? 1 : 0,
        type: selectedType === "1:1 Call" ? constant.ONE_ON_ONE_CALL : constant.TEXT_QUERY,
        availability: "default",
        displayPriority: nextDisplayPriority,
      };

      if (selectedType === "1:1 Call") {
        payload.callDuration = callDuration !== "Custom" ? callDuration : customCallValue;
      }

      axios
        .post(url.POST_SERVICE_ADD, payload, {
          headers: authHeader(),
        })
        .then((response) => {
          if (response.request.status === 200) {
            toast.success("Service is added to your profile!", {
              position: toast.POSITION.TOP_CENTER,
            });
            navigate(-1);
          }
        });
    }
  } else {
    setErrors((prevErrors) => (prevErrors !== errors ? errors : prevErrors));
  }
}


  function checkValidation() {
    let errors = {};
    const {
      selectedType,
      title,
      shortDescription,
      description,
      selectedPrice,
      customPriceValue,
      callDuration,
      customCallValue,
    } = serviceJson;
    if (!selectedType) errors.selectedType = "Please choose a service type!";
    if (!title) errors.title = "Title must be entered!";
    if (!shortDescription)
      errors.shortDescription = "Short Description must be entered!";
    if (!description) errors.description = "Description is mandatory";

    if (callDuration === "Custom") {
      if (!customCallValue) {
        errors.customCallValue = "Field is required!";
      } else {
        const value = parseInt(customCallValue, 10);
        if (isNaN(value) || value < 10 || value > 120) {
          errors.customCallValue =
            "Please enter call duration between 10-120 minutes.";
        }
      }
    }

    if (selectedPrice === "Custom" && !customPriceValue) {
      errors.customPriceValue = "Field is required!";
    }

    return errors;
  }

  // --- Automatic displayPriority assignment ---
 async function getNextDisplayPriority() {
  try {
    const response = await axios.get(
      `${url.GET_ALL_SERVICE}?username=${username}`,
      { headers: authHeader() }
    );

    const services = response.data || [];
    if (!services.length) return "1";

    // Sort correctly: 1, 1_1, 2, 2_2 etc.
    services.sort((a, b) => {
      const aVal = a.displayPriority.replace("_", ".");
      const bVal = b.displayPriority.replace("_", ".");
      return parseFloat(bVal) - parseFloat(aVal);
    });

    const last = services[0].displayPriority;

    // If last = "3" → next = "3_3"
    if (!last.includes("_")) {
      return `${last}_${last}`;
    }

    // If last = "3_3" → next = "4"
    const base = parseInt(last.split("_")[0], 10);
    return (base + 1).toString();

  } catch (err) {
    console.error("Error fetching services:", err);
    return "1";
  }
}
  
  useEffect(() => {
    setErrors({});
  }, [serviceJson.selectedType]);

  function handleCancelClick() {
    setShowCancelPopup(true);
  }

  function handleKeepEditing() {
    setShowCancelPopup(false);
  }

  function handleDiscardChanges() {
    setServiceJson(initialState);
    setShowCancelPopup(false);
  }

  //returning the form for selected type
  function getForm() {
    return (
      <div className="ServiceForm d-flex flex-column flex-wrap">
        <div className="form-group">
          <label className="form-label-title-field mb-2">Service Name</label>
          <input
            type="text"
            className={`form-control ${
              errors.shortDescription ? "input-error" : ""
            }`}
            id="title-field"
            name="title"
            placeholder="Name of Service"
            value={serviceJson.title}
            onChange={handleChange}
          />
         
          {errors.title ? ( <div className="error-message">
           <i class="fa-regular fa-circle-xmark fa-sm" style={{color:"#ef4444",flexShrink: "0",marginTop:"-3px"}}></i> <span className="text-danger">{errors.title}</span></div>
          ) : ( 
            ""
          )}
         
        </div>
        <div className="form-group">
          <label className="form-label" title="Short Description">
            Short Description
          </label>

          <input
            type="text"
            className={`form-control ${
              errors.shortDescription ? "input-error" : ""
            }`}
            id="short-field"
            name="shortDescription"
            placeholder="Brief summary of your service(1-2 sentences)"
            value={serviceJson.shortDescription}
            onChange={handleChange}
          />
          {errors.shortDescription ? (
           <div className="error-message">
           <i class="fa-regular fa-circle-xmark fa-sm" style={{color:"#ef4444",flexShrink: "0",marginTop:"-3px"}}></i> <span className="text-danger">{errors.shortDescription}</span></div>
          ) : (
            ""
          )}
        </div>
        <div className="form-group">
          <label className="form-label" title="Description">
            Description
          </label>
          <div className="quill custom-quill">
            <div
              className={`editor ${
                errors.shortDescription ? "input-error" : ""
              }`}
            >
              <Editor
                value={edit ? serviceJson.description : ""}
                onEditorChange={handleEditorChange}
              />
            </div>
            {errors.description ? (
              <div className="error-message">
           <i class="fa-regular fa-circle-xmark fa-sm" style={{color:"#ef4444",flexShrink: "0",marginTop:"-3px"}}></i>
              <span className="text-danger">{errors.description}</span></div>
            ) : (
              ""
            )}
          </div>
        </div>

        {serviceJson.selectedType !== "Text Query" ? (
          <div className="form-group">
            <div className="row">
              <div className="col-12">
                <label className="form-label-title-field mb-2">
                  Calls In(Mins)
                </label>
              </div>
            </div>

            <div className="d-flex flex-row flex-wrap gap-2">
              {callsButtons.map((bu, index) => (
                <button
                  className={`btn calls-button-${index} ${
                    serviceJson.callDuration
                      ? serviceJson.callDuration === bu.value
                        ? "activeButton"
                        : "btn-custom"
                      : "btn-custom"
                  }`}
                  value={bu.value}
                  onClick={() =>
                    setServiceJson({ ...serviceJson, callDuration: bu.value })
                  }
                  key={index}
                >
                  {bu.value === "Custom" ? bu.value : bu.value + " Min"}
                </button>
              ))}
            </div>
          </div>
        ) : (
          ""
        )}

        {serviceJson.callDuration === "Custom" &&
        serviceJson.selectedType !== "Text Query" ? (
          <div className="form-group">
            <label className="form-label-title-field mb-2">
              Custom Call Duration (Mins)
            </label>
            <input
              className="form-control"
              type="number"
              min="10"
              id="custom-call-ref"
              name="customCallValue"
              value={serviceJson.customCallValue}
              onChange={handleChange}
            />

            {errors.customCallValue ? (
              <span className="text-danger">{errors.customCallValue}</span>
            ) : (
              ""
            )}
          </div>
        ) : (
          ""
        )}

        {/* Date picker will be setup for webinar later*/}
        {/* <div className="form-group">
          <DatePicker onChange={onChange} value={value} />
        </div> */}

        <div className="form-group">
          <label className="form-label-title-field mb-2">Price (Rs.)</label>

          <div className="addService-price-btn d-flex flex-row flex-wrap gap-2">
            {priceButtons.map((bu, index) => (
              <button
                className={`btn price-button-${index} ${
                  serviceJson.selectedPrice
                    ? serviceJson.selectedPrice === bu.value
                      ? "activeButton"
                      : "btn-custom"
                    : "btn-custom"
                }`}
                value={bu.value}
                style={{ width: "6rem" }}
                onClick={() =>
                  setServiceJson({ ...serviceJson, selectedPrice: bu.value })
                }
                key={index}
              >
                {bu.value === "Custom" ? bu.value : "Rs." + bu.value}
              </button>
            ))}
          </div>
        </div>

        {serviceJson.selectedPrice === "Custom" ? (
          <div className="form-group">
            <div className="row">
              <div className="col-12">
                <label className="form-label-title-field mb-2">
                  Custom Price (Rs.)
                </label>
              </div>
            </div>
            <div className="row">
              <div className="col-12">
                <input
                  className="form-control"
                  type="number"
                  min="1"
                  id="custom-price"
                  name="customPriceValue"
                  value={serviceJson.customPriceValue}
                  onChange={handleChange}
                />
              </div>

              {errors.customPriceValue ? (
                <span className="text-danger">{errors.customPriceValue}</span>
              ) : (
                ""
              )}
            </div>
          </div>
        ) : (
          ""
        )}

        <div className="d-flex flex-row justify-content-start align-items-center py-3 p-2 gap-3">
          <label className="switch m-0 d-flex">
            <input
              type="checkbox"
              checked={serviceJson.hideInProfileFlag}
              onChange={(event) => handleToggleButton(event)}
            />
            <span className="slider"></span>
          </label>

          <div className="toggle-text">
            Hide this service from my public profile
          </div>
        </div>
        <div className="d-flex flex-row gap-3">
          <div className="btn btn-lg cancel-btn" onClick={handleCancelClick}>
            Cancel
          </div>
          <div className="btn btn-lg confirm-btn" onClick={handleConfirm}>
            {edit ? "Update Details" : "Confirm"}
            <i
              className="fa-solid fa-arrow-right"
              style={{ color: "#ffffff" }}
            ></i>
          </div>
        </div>
      </div>
    );
  }
  function handleChange(event) {
    const { name, value } = event.target;
    setServiceJson((prevState) => ({ ...prevState, [name]: value }));
  }
  return (
    <div className="addingService" style={{ background: "#f9fafb" }}>
      <div className="header">
        <div
          className="header-title d-flex flex-row ml-0"
          style={{ gap: "1rem" }}
        >
          <div className="back-button d-flex flex-column justify-content-center">
            <i
              className="fa-solid fa-arrow-left"
              onClick={goBack}
              style={{ cursor: "pointer" }}
            ></i>
          </div>

          <div className="header-title-add-service">
            <p className="text-start fs-2 mb-0 fw-bold mt-3">
              {edit ? "Edit Service" : "Add New Service"}
            </p>
            <p class="subtitle ">
              Create a new service offering for your clients
            </p>
          </div>
        </div>
      </div>

      <div className="main">
        <div className="container-fluid new-service-main-container">
          <div className="row">
            <div className="col-6 rounded">
              <div className="row">
  <div className="col-12">
    <div className="Service-Type">
      <div className="form-label-title-field Type-heading text-bold mb-2">
        Service Type
      </div>

      <div className="Type-content">
        <div className={`d-flex flex-wrap gap-2 ${errors.selectedType ? "error-type" : ""}`}>
          {serviceTypeList.map((service, index) => (
            <div className={`content-${index}`} key={index}>
              <button
                className={`type-button btn ${
                  serviceJson.selectedType?.trim() === service.name ? "activeButton" : "btn-custom"
                }`}
                // disabled={edit}   // <-- TYPE LOCKED IN EDIT MODE
                 onClick={() =>
                  setServiceJson((prev) => ({
                    ...prev,
                    // normalize stored value
                    selectedType: service.name.trim(),
                    // if switching to Text Query, clear call duration related fields
                    ...(service.name === "Text Query"
                      ? { callDuration: "", customCallValue: "" }
                      : {}),
                  }))
                }
              >
                <span
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                  }}
                >
                  {React.cloneElement(service.icon, {
                    style: {
                      color:
                        serviceJson.selectedType === service.name
                          ? "white"
                          : "rgb(134 133 133)",
                    },
                  })}
                  <span>{service.name}</span>
                </span>
              </button>
            </div>
          ))}
        </div>

        {errors.selectedType && (
          <div className="error-message">
            <i class="fa-regular fa-circle-xmark fa-sm" style={{color:"#ef4444"}}></i>
            <span className="text-danger">{errors.selectedType}</span>
          </div>
        )}
      </div>
    </div>
  </div>
</div>


              {getForm()}
            </div>
          </div>
        </div>
      </div>
      {showCancelPopup && (
        <div className="cancel-popup-overlay">
          <div className="cancel-popup">
            <div className="d-flex align-items-center gap-3 mb-3">
              <i
                className="fa-solid fa-triangle-exclamation fa-xl"
                style={{ color: "#ef4444" }}
              ></i>{" "}
              <h4 className="modal-title ">Discard Changes?</h4>
            </div>
            <h5 className="modal-message">
              Are you sure you want to cancel? Any unsaved changes will be lost
              and cannot be recovered.
            </h5>

            <div className="d-flex gap-3 mt-3 justify-content-end">
              <button className=" modal-btn-cancel" onClick={handleKeepEditing}>
                Keep Editing
              </button>
              <button
                className="btn btn-danger modal-btn-confirm"
                onClick={goBack}
              >
                Discard Changes
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default AddingService;
